import React from 'react';
import './ComingSoon.css';

function ComingSoon() {
  return (
    <section className="coming-soon">
      <h2>🚀 Launching Soon</h2>
      <p>Curated dashboards, templates, and tools for modern finance professionals. Be the first to access them.</p>

      <div className="preview-grid">
        <img src="/assets/preview-blur.png" alt="Product Grid Preview" />
      </div>

      <div className="notify-box">
        <p>👀 Want early access?</p>
        <a href="mailto:alamoudison@gmail.com?subject=Early Access - Products" className="btn-soon">Notify Me</a>
      </div>
    </section>
  );
}

export default ComingSoon;